import { Switch } from '@headlessui/react'
import { useEffect } from "react";

const ToggleSwitch = ({ enabled, setEnabled, storageToggleId = null }) => {

  useEffect(() => {
    if (storageToggleId) {
      const storedValue = localStorage.getItem(storageToggleId);
      if (storedValue !== null) {
        setEnabled(JSON.parse(storedValue));
      }
    }
  }, [storageToggleId, setEnabled]);

  const handleToggle = (newState) => {
    if (storageToggleId) {
      localStorage.setItem(storageToggleId, JSON.stringify(newState));
    }
    setEnabled(newState);
  }

  return (
    <Switch
      checked={enabled}
      onChange={handleToggle}
      className={`group relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:ring-offset-2 ${enabled ? 'bg-perception-blue' : ''}`}
    >
      <span className="sr-only">Use setting</span>
      <span className={`pointer-events-none relative inline-block size-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${enabled ? 'translate-x-5' : ''}`}>
        <span
          aria-hidden="true"
          className={`absolute inset-0 flex size-full items-center justify-center transition-opacity duration-200 ease-in ${enabled ? 'opacity-0' : 'opacity-100'}`}
        >
          <svg fill="none" viewBox="0 0 12 12" className="size-3 text-gray-400">
            <path
              d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        <span
          aria-hidden="true"
          className={`absolute inset-0 flex size-full items-center justify-center transition-opacity duration-100 ease-out ${enabled ? 'opacity-100' : 'opacity-0'}`}
        >
          <svg fill="currentColor" viewBox="0 0 12 12" className="size-3 text-perception-blue">
            <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
          </svg>
        </span>
      </span>
    </Switch>
  )
}

export default ToggleSwitch